"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./_DropdownFormControl.scss");
var DropdownFormControl = function (_a) {
    var id = _a.id, label = _a.label, isEnabled = _a.isEnabled, options = _a.options, selectedValue = _a.selectedValue, handleChange = _a.handleChange;
    return (react_1.default.createElement("div", { className: "spr-dropdown-formcontrol mb-3" },
        react_1.default.createElement("label", { htmlFor: id }, label),
        react_1.default.createElement("select", { id: id, className: "spr-dropdown-formcontrol__form-select form-select", disabled: !isEnabled || options.length <= 1, value: selectedValue, onChange: handleChange }, options.map(function (option, index) { return (react_1.default.createElement("option", { key: index, value: option.Value, selected: option.Value === selectedValue }, option.Name)); }))));
};
DropdownFormControl.displayName = "Dropdown Form Control";
exports.default = DropdownFormControl;
